import { atom } from 'jotai';

export const settingModalScrollContainerAtom = atom<HTMLElement | null>(null);
